import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminService } from '../../../admin/admin.service';
import { Unit } from '../../../models/admin-models';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { saveAs } from '@progress/kendo-file-saver';
import { SessionStorageService } from '../../../services/session-storage.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxLoadingModule } from 'ngx-loading';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-active-users',
  templateUrl: './active-users.component.html',
  styleUrls: ['./active-users.component.scss'],
  imports: [
    NgxLoadingModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ActiveUsersComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private ss = inject(SessionStorageService);
  dialog = inject(MatDialog);

  @Input() baseUrl;

  unitsControl = new FormControl();
  units: Unit[] = [] as Unit[];
  filteredUnits = [];
  selectedUnit;
  reportTypes = [
    { value: 'csv', label: 'CSV' },
    { value: 'json', label: 'JSON' },
  ];
  selectedType;
  loading = false;
  rolesToSearch: string = '';
  includeInactive = false;

  ngOnInit(): void {
    this.getUnits();
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnitActiveUsers() {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.loading = true;
        const iosSafari =
          this.pltfrm.IOS ||
          (navigator?.['userAgentData']?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

        this.admnSvc
          .getUnitActiveUsersReport(
            this.selectedUnit,
            this.selectedType,
            this.includeInactive,
            this.rolesToSearch
          )
          .subscribe(data => {
            const filename = `${this.selectedUnit}_${this.selectedType}_report.${this.selectedType}`;

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });
            };
            this.loading = false;
          });
      }
      dialogRef = null;
    });
  }
}
